import Images from 'constants/images';

const dataManagementAreas = () => {
  const areas = [
    {
      area: 'report99',
      title: 'Report 99',
      imgSrc: Images.dataEntryAreas,
      href: '/data_management/report99',
    },
  ];
  return areas;
};

export default dataManagementAreas;
